import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getMonument(context) {
      let response = await Vue.axios.get(
        `${URL_API}architecture/getbytype?architecture_type_id=2`
      );
      let data = response["data"];
      context.commit("updateMonument", data);
      return data;
    }
  },
  mutations: {
    updateMonument(state, data) {
      state.monument = data;
    }
  },
  state: {
    monument: {}
  },
  getters: {
    allMonument(state) {
      return state.monument;
    }
  }
};
